import StandstillIncident from './StandstillIncident';

export default StandstillIncident;
